function before( el, referenceNode ) {
	referenceNode.parentNode.insertBefore( el, referenceNode );
}

function after( el, referenceNode ) {
	referenceNode.parentNode.insertBefore( el, referenceNode.nextSibling );
}

export default {
	before,
	after,
};
